import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/opd.scss";
import { Button, Select, Row, Col, Input, InputNumber, Checkbox } from "antd";
import HeaderBar from "../../../components/header/headerBar";
import axios from "axios";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import LOGO from "../../../assets/images/logo.png";

interface Props {
  data?: any;
  refPrint?: any;
}

const PrintPage1: React.FC<Props> = ({ data, refPrint }) => {
  const history = useHistory();
  const refPrintV1: any = useRef("pagePrintV1");
  // const [data, setdata] = useState<any>([]);

  return (
    <div className="opd-custom-list">
      <div
        ref={refPrint}
        className="page-print-v1"
        style={{ marginTop: "20px", background: "#FFFFFF" }}
      >
        {console.log("data", data)}
        <Row>
          <Col span={8} offset={8}>
            <img src={LOGO} alt="Dermaster" style={{ width: "100%" }} />
          </Col>
          <Col span={8} style={{ alignSelf: "flex-end", textAlign: "end" }}>
            <p>
              <span>สาขา : {data?.branch}</span>
            </p>
          </Col>
        </Row>

        <div className="line-title"></div>

        <Row className="title-print">
          <Col span={8}>
            <p>
              ชื่อ (Name): <span>{data?.name}</span>
            </p>
          </Col>
          <Col span={8}>
            <p>
              ชื่อเล่น (Nickname):{" "}
              <span>{data?.nickName ? data?.nickName : "-"}</span>
            </p>
          </Col>
          <Col span={8} style={{ textAlign: "end" }}>
            <p>
              <span>{data?.code}</span>
            </p>
          </Col>
        </Row>

        <div className="line-title"></div>

        <Row>
          <Col span={24} className="history">
            <p>
              แพ้ยา (Allergy History): <span>{data?.allergyHistory}</span>
            </p>
          </Col>
        </Row>

        <Row>
          <Col span={24} className="history">
            <p>
              โรคประจำตัว (UnderlyingDisease):{" "}
              <span>{data?.underlyingDisease}</span>
            </p>
          </Col>
        </Row>

        <div className="text-print">
          <Row>
            <Col span={24}>
              <p>
                หมายเลขบัตรประชาชน (ID Card): <span>{data?.idCard}</span>
              </p>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <p>
                วัน/เดือน/ปีเกิด (Birthdate) : <span>{data?.birthdate}</span>
              </p>
            </Col>
            <Col span={8}>
              <p>
                อายุ (Age) : <span>{data?.age}</span>
              </p>
            </Col>
            <Col span={8}>
              <p>
                เพศ (Gender) : <span>{data?.gender}</span>
              </p>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <p>
                น้ำหนัก (Weight) : <span>{data?.weight} kg.</span>
              </p>
            </Col>
            <Col span={8}>
              <p>
                ส่วนสูง (Height) : <span>{data?.height} cm.</span>
              </p>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <p>
                กรุ๊ปเลือด (BloodType) :
                <span>{data?.bloodtype !== 0 ? data?.bloodtype : "-"}</span>
              </p>
            </Col>
          </Row>

          <div className="line-title"></div>

          <div style={{ margin: "20px 0px" }}>
            <Row>
              <Col span={24}>
                <p>
                  ที่อยู่ (Address):{" "}
                  <span>{data?.address ? data?.address : "-"}</span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <p>
                  เบอร์ติดต่อหลัก (Primary Contact Number):{" "}
                  <span>
                    {data?.phoneNumbersFirst
                      ? "+" +
                        data?.phoneNumbersFirst?.code +
                        " " +
                        data?.phoneNumbersFirst?.phone
                      : "-"}
                  </span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <p>
                  เบอร์ติดต่อรอง (Secondary Contact Number):{" "}
                  <span>
                    {data?.phoneNumbersSecond
                      ? "+" +
                        data?.phoneNumbersSecond?.code +
                        " " +
                        data?.phoneNumbersSecond?.phone
                      : "-"}
                  </span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <p>
                  อีเมล (Email): <span>{data?.email}</span>
                </p>
              </Col>
            </Row>
          </div>

          <div className="line-title"></div>

          <div style={{ margin: "20px 0px" }}>
            <Row>
              <Col span={8}>
                <p>
                  ชื่อผู้ติดต่อ (Contacts):{" "}
                  <span>{data?.contacts ? data?.contacts : "-"}</span>
                </p>
              </Col>
              <Col span={16}>
                <p>
                  เบอร์มือถือผู้ติดต่อ (ContactsMobile):
                  <span>
                    {data?.contactsMobile?.phone
                      ? "+" +
                        data?.contactsMobile?.code +
                        " " +
                        data?.contactsMobile?.phone
                      : " -"}
                  </span>
                </p>
              </Col>
            </Row>
          </div>

          <div className="line-title"></div>
        </div>
      </div>
    </div>
  );
};
export default PrintPage1;
